import { render, staticRenderFns } from "./shareToParent.vue?vue&type=template&id=29775cfa&scoped=true&"
import script from "./shareToParent.vue?vue&type=script&lang=js&"
export * from "./shareToParent.vue?vue&type=script&lang=js&"
import style0 from "./shareToParent.vue?vue&type=style&index=0&id=29775cfa&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29775cfa",
  null
  
)

export default component.exports